import { CustomerSearchHistoryQuery, ContextInput } from "__generated__/api";
import HistoryPropertyDetailInlineFragment = CustomerSearchHistoryQuery.HistoryPropertyDetailInlineFragment;
import { HotelsGroupedByDates } from "../typings";
import { HotelsStore } from "stores/HotelsStore";

/**
 * Builds a variables list that matches the dates with the hotels the user looked for.
 * Returns an array, each place in the array is a variable that you need to pass a param
 * to the query you are calling to.
 * @param hotelsGroupedByDates Object that contains keys for the dates and arrays for the values in which contains the hotels associated with that date
 * @param context App context
 * @param hotelsStore Hotels store
 */

export const buildVariablesList = (
  hotelsGroupedByDates: HotelsGroupedByDates,
  context: ContextInput,
  hotelsStore: HotelsStore
) =>
  Object.keys(hotelsGroupedByDates)
    .filter((dates) => hotelsGroupedByDates[dates].length > 0)
    .map((dates) => {
      const hotels = hotelsGroupedByDates[dates];
      /* istanbul ignore next line */
      const hotelIds = hotels
        .map((hotel) => (hotel.productInfo as HistoryPropertyDetailInlineFragment)?.propertyId)
        .filter((id) => typeof id === "string") as string[];
      const { startDate, endDate } = hotels[0];

      return {
        context,
        hotelIds,
        dateRange: hotelsStore.formatDate(startDate, endDate),
      };
    });
